import { Divider, Space } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { HiddenWidgetsList } from './elements/HiddenWidgetsList'
import * as Styled from './styles'

export const HiddenWidgets = () => {
  const { t } = useTranslation()

  return (
    <>
      <Styled.SeparatorGridItem>
        <Space size="s32" />
        <Divider>{t('dashboard.widget.hidden.title')}</Divider>
        <Space size="s32" />
      </Styled.SeparatorGridItem>
      <HiddenWidgetsList />
    </>
  )
}
